// The ONLY module that knows the RFC 7807 problem shape ApiProblems.cs (Boundary/ApiProblems.cs)
// emits: `status`, `title`, `detail`, plus three extension members - `reasonCode`, `operation`,
// `issues` - and a `correlationId` the boundary also stamps (Boundary/CallerContextSource.cs,
// X-Correlation-Id). Everything downstream of http.ts sees a typed ApiError, never a raw
// ProblemDetails object.
import type { ValidationIssue } from "./generated/contracts";

export interface ProblemDetailsBody {
  readonly status?: number;
  readonly title?: string;
  readonly detail?: string;
  readonly reasonCode?: string;
  readonly operation?: string;
  readonly issues?: ValidationIssue[];
  readonly correlationId?: string;
}

export function isProblemDetailsBody(value: unknown): value is ProblemDetailsBody {
  return typeof value === "object" && value !== null;
}
